export const MAX_CROP_WIDTH = 1313;
export const MAX_CROP_HEIGHT = 400;
export const MIN_CROP_WIDTH = 192;
export const MIN_CROP_HEIGHT = 40;
export const CROP_ASPECT = 1920 / 400;
